import _pt from "prop-types";

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(a, b) {
  if (null == a) return {};
  var c,
      d,
      e = {},
      f = Object.keys(a);

  for (d = 0; d < f.length; d++) {
    c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
  }

  return e;
}

function _assertThisInitialized(a) {
  if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}

function _inheritsLoose(a, b) {
  a.prototype = Object.create(b.prototype), a.prototype.constructor = a, a.__proto__ = b;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

import React from "react";
import { vega } from "vega-embed";
import VegaEmbed from "./VegaEmbed";
import isFunction from "./utils/isFunction";
import shallowEqual from "./utils/shallowEqual";
import { NOOP } from "./constants";
import getDatasetNamesFromSpec from "./utils/getDatasetNamesFromSpec";

function updateData(a, b, c) {
  c && (isFunction(c) ? c(a.data(b)) : a.change(b, vega.changeset().remove(function () {
    return !0;
  }).insert(c)));
}

var EMPTY = {},
    Vega =
/*#__PURE__*/
function (a) {
  function b() {
    for (var b, c = arguments.length, d = Array(c), e = 0; e < c; e++) {
      d[e] = arguments[e];
    }

    return b = a.call.apply(a, [this].concat(d)) || this, _defineProperty(_assertThisInitialized(b), "vegaEmbed", React.createRef()), _defineProperty(_assertThisInitialized(b), "handleNewView", function (a) {
      b.update();
      var c = b.props.onNewView,
          d = void 0 === c ? NOOP : c;
      d(a);
    }), b;
  }

  _inheritsLoose(b, a);

  var c = b.prototype;
  return c.componentDidMount = function componentDidMount() {
    this.update();
  }, c.componentDidUpdate = function componentDidUpdate(a) {
    shallowEqual(this.props.data, a.data) || this.update();
  }, c.update = function update() {
    var a = this.props,
        b = a.data,
        c = a.spec;

    if (b) {
      var d = getDatasetNamesFromSpec(c).filter(function (a) {
        return b[a];
      });
      this.vegaEmbed.current && 0 < d.length && this.vegaEmbed.current.modifyView(function (a) {
        d.forEach(function (c) {
          updateData(a, c, b[c]);
        }), a.run();
      });
    }
  }, c.render = function render() {
    var a = this.props,
        b = a.data,
        c = _objectWithoutPropertiesLoose(a, ["data"]);

    return React.createElement(VegaEmbed, _extends({
      ref: this.vegaEmbed
    }, c, {
      onNewView: this.handleNewView
    }));
  }, b;
}(React.PureComponent);

_defineProperty(Vega, "propTypes", {
  data: _pt.any
}), _defineProperty(Vega, "defaultProps", {
  data: EMPTY
});
export { Vega as default };